export default {
      id: "home-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#home",
      toString: function () {
        return this.url;
      }
    }